var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-action-dialog',{attrs:{"api-call":_vm.apiCall,"action":"Delete"},on:{"close":_vm.close}},[_vm._v(" Are you sure? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }